<template>
  <div
    class="modal fade"
    id="studioInfoWModal"
    tabindex="-1"
    aria-labelledby="studioInfoWModalLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex">
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              STUDIO 등록하기
            </h1>
          </div>
        </div>
        <div class="modal-division" />
        <div class="modal-body" style="padding-top: 1rem">
          <div class="modalDivWrap">
            <div class="modalPartTitle">STUDIO 정보 등록</div>
            <div class="modalInputDiv">
              <label>사업자등록번호<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="사업자등록 번호를 입력해주세요 (ex. 123-45-67890)"
                v-model="businessNumber"
                maxlength="12"
                @input="changeBusinessNumber"
                @keyup.enter="businessNumberValidate"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0 !important"
                  @click="businessNumberValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0 !important">
              <label />
              <span class="businessNumberMsgW fail"></span>
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>스튜디오명<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="스튜디오명을 입력하세요."
                v-model="studioName"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>대표자명</label>
              <input
                type="text"
                placeholder="대표자명을 입력하세요."
                v-model="ceoName"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>대표 전화번호</label>
              <input
                type="text"
                placeholder="대표 전화번호를 입력해주세요 (ex. 02-1234-5678)"
                v-model="phoneNumber"
                maxlength="13"
                @input="changePhoneNumber"
              />
              <div class="modalInputRight" />
            </div>
          </div>

          <div class="modalDivWrap">
            <div class="modalPartTitle">관리자 정보 등록</div>
            <div class="modalInputDiv">
              <label>관리자 이름<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="해당 STUDIO의 관리자 이름을 입력해주세요."
                v-model="managerName"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>관리자 직급</label>
              <input
                type="text"
                placeholder="관리자의 직급을 입력해주세요."
                v-model="managerDuty"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>관리자 연락처<span class="requiredSpan">*</span></label>
              <input
                type="text"
                placeholder="관리자의 연락처를 입력해주세요."
                v-model="managerPhoneNumber"
                maxlength="13"
                @input="changeManagerPhoneNumber"
              />
              <div class="modalInputRight" />
            </div>
            <input
              type="text"
              placeholder="관리자의 아이디를 입력해주세요."
              style="display: none !important"
            />
            <input
              type="password"
              placeholder="비밀번호를 입력해주세요."
              @input="passwordOnChange"
              style="display: none !important"
            />
            <div class="modalInputDiv">
              <label>관리자 아이디</label>
              <input
                type="text"
                placeholder="관리자의 아이디를 입력해주세요."
                v-model="managerId"
                @keyup.enter="managerIdValidate"
                @input="changeManagerId"
              />
              <div class="modalInputRight">
                <button
                  class="btn btn-primary modalBtnRight"
                  style="margin-bottom: 0 !important"
                  @click="managerIdValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv" style="padding: 0 !important">
              <label />
              <span class="managerIdMsgW fail"></span>
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>관리자 비밀번호</label>
              <input
                type="password"
                placeholder="비밀번호를 입력해주세요. (8자리 이상)"
                v-model="password"
                @input="passwordOnChange"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv">
              <label>비밀번호 확인</label>
              <input
                type="password"
                placeholder="비밀번호를 다시 입력해주세요."
                v-model="passwordConfirm"
                @input="passwordOnChange"
              />
              <div class="modalInputRight" />
            </div>
            <div class="modalInputDiv" style="padding: 0 !important">
              <label />
              <span class="passwordMsgW fail"></span>
              <div class="modalInputRight" />
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666"
          >
            취소
          </button>
          <button type="button" class="btn btn-info" @click="addStudio()">
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  openDialog,
  businessNumberFormatter,
  phoneNumberFormatter,
} from "@/utils/utils";

export default {
  emits: ["reload"],
  data() {
    return {
      type: "STUDIO",

      studioName: "",
      ceoName: "",
      phoneNumber: "",
      businessNumber: "",

      managerName: "",
      managerDuty: "",
      managerPhoneNumber: "",
      managerId: "",
      password: "",
      passwordConfirm: "",

      isBusinessNumberValid: false,
      isPasswordValid: false,
      isManagerIdValid: false,
    };
  },

  async mounted() {
    this.initValues();
  },
  methods: {
    changePhoneNumber() {
      this.phoneNumber = phoneNumberFormatter(this.phoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(
        this.managerPhoneNumber.toString()
      );
    },
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if (document.querySelector(".businessNumberMsgW"))
        document.querySelector(".businessNumberMsgW").innerHTML = "";
    },
    changeManagerId() {
      this.isManagerIdValid = false;
      if (document.querySelector(".managerIdMsgW"))
        document.querySelector(".managerIdMsgW").innerHTML = "";
    },

    async addStudio() {
      if (await this.validateData()) {
        try {
          const obj = {};

          obj.name = this.studioName;
          if (this.ceoName) obj.ceo = this.ceoName;
          obj.cNo = this.businessNumber.replace(/-/g, "");
          obj.medicalDept = [];

          if (this.phoneNumber) {
            obj.call = this.phoneNumber.replace(/-/g, "");
          } else {
            obj.call = "";
          }
          obj.type = this.type;

          const accountInfo = {};
          if (this.managerId) {
            accountInfo.username = this.managerId.trim();
            accountInfo.password = this.password;
          }
          accountInfo.role = this.type;
          if (this.managerName) accountInfo.name = this.managerName;
          if (this.managerDuty) accountInfo.duty = this.managerDuty;
          if (this.managerPhoneNumber)
            accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
          obj.accountInfo = accountInfo;

          const response = await this.$apiInstance.post(`/companies`, obj);
          if (response.status === 200 || response.status === 201) {
            await openDialog(
              "STUDIO 등록이 완료되었습니다.",
              "success",
              "확인"
            ).then(() => {
              location.reload();
            });
          } else {
            await openDialog("STUDIO 등록에 실패하였습니다.", "error", "확인");
          }
        } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 400) {
            const errorMsg =
              error.response.data?.message || "이미 존재하는 계정입니다.";
            await openDialog(errorMsg, "error", "확인");
          } else {
            await openDialog("STUDIO 등록에 실패하였습니다.", "error", "확인");
          }
        }
      }
    },

    async businessNumberValidate() {
      const businessNumberMsg = document.querySelector(".businessNumberMsgW");
      if (this.businessNumber.replaceAll("-", "").length < 10) {
        businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
        businessNumberMsg.innerHTML = "잘못된 사업자등록번호입니다.";
        this.isBusinessNumberValid = false;
      } else {
        const response = await this.$apiInstance.get(
          `/companies/duplicateCheck/cNo/${this.businessNumber}`
        );
        if (
          response &&
          (response.status === 200 || response.status === 201) &&
          !response.data
        ) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW success");
          businessNumberMsg.innerHTML = "사용할 수 있는 사업자등록번호입니다.";
          this.isBusinessNumberValid = true;
        } else {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.innerHTML = "이미 존재하는 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },

    async managerIdValidate() {
      const managerIdMsgW = document.querySelector(".managerIdMsgW");
      if (!this.managerId.trim()) {
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        managerIdMsgW.innerHTML = "관리자 아이디를 입력해주세요.";
        this.isManagerIdValid = false;
        return;
      }
      try {
        const response = await this.$apiInstance.get(
          `/accounts/duplicateCheck/${encodeURIComponent(this.managerId.trim())}`
        );
        if (
          response &&
          (response.status === 200 || response.status === 201) &&
          !response.data
        ) {
          managerIdMsgW.setAttribute("class", "managerIdMsgW success");
          managerIdMsgW.innerHTML = "사용할 수 있는 아이디입니다.";
          this.isManagerIdValid = true;
        } else {
          managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
          managerIdMsgW.innerHTML = "이미 존재하는 아이디입니다.";
          this.isManagerIdValid = false;
        }
      } catch (error) {
        console.log(error);
        // 숫자 10자리(사업자번호 모양) 등 서버가 막은 이유를 그대로 보여준다.
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        managerIdMsgW.textContent =
          error.response?.data?.message ||
          "아이디 중복확인에 실패했습니다. 다시 시도해 주세요.";
        this.isManagerIdValid = false;
      }
    },

    passwordOnChange() {
      this.passwordValidate();
    },

    passwordValidate() {
      const passwordMsg = document.querySelector(".passwordMsgW");
      if (!this.password) {
        this.isPasswordValid = false;
        passwordMsg.setAttribute("class", "passwordMsgW");
        passwordMsg.innerHTML = "";
        return;
      }
      if (this.password.length < 8) {
        this.isPasswordValid = false;
        passwordMsg.setAttribute("class", "passwordMsgW fail");
        passwordMsg.innerHTML = "비밀번호는 8자리 이상이어야 합니다.";
      } else if (this.password !== this.passwordConfirm) {
        this.isPasswordValid = false;
        passwordMsg.setAttribute("class", "passwordMsgW fail");
        passwordMsg.innerHTML = "비밀번호가 일치하지 않습니다.";
      } else {
        this.isPasswordValid = true;
        passwordMsg.setAttribute("class", "passwordMsgW success");
        passwordMsg.innerHTML = "사용 가능한 비밀번호입니다.";
      }
    },

    async validateData() {
      if (!this.isBusinessNumberValid) {
        await openDialog(
          "사업자등록번호 중복확인을 해주세요.",
          "error",
          "확인"
        );
        return false;
      }
      if (!this.studioName) {
        await openDialog("스튜디오명을 입력해주세요.", "error", "확인");
        return false;
      }
      if (!this.managerName) {
        await openDialog("관리자 이름을 입력해주세요.", "error", "확인");
        return false;
      }
      if (!this.managerPhoneNumber) {
        await openDialog("관리자 연락처를 입력해주세요.", "error", "확인");
        return false;
      }
      if (this.managerId && !this.isManagerIdValid) {
        await openDialog("관리자 아이디 중복확인을 해주세요.", "error", "확인");
        return false;
      }
      if (this.managerId && !this.password) {
        await openDialog("관리자 비밀번호를 입력해주세요.", "error", "확인");
        return false;
      }
      if (this.managerId && this.password && !this.passwordConfirm) {
        await openDialog("비밀번호 확인을 입력해주세요.", "error", "확인");
        return false;
      }
      if (this.managerId && this.password && this.password.length < 8) {
        await openDialog(
          "비밀번호는 8자리 이상이어야 합니다.",
          "error",
          "확인"
        );
        return false;
      }
      if (
        this.managerId &&
        this.password &&
        this.password !== this.passwordConfirm
      ) {
        await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
        return false;
      }
      return true;
    },

    initValues() {
      this.studioName = "";
      this.ceoName = "";
      this.phoneNumber = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerDuty = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.password = "";
      this.passwordConfirm = "";
      this.isBusinessNumberValid = false;
      this.isPasswordValid = false;
      this.isManagerIdValid = false;
    },
  },
};
</script>
<style scoped>
.requiredSpan {
  color: red;
  margin-left: 2px;
}
.modalDivWrap {
  padding: 1rem;
  border-bottom: 1px solid #eee;
}
.modalPartTitle {
  font-weight: bold;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}
.modalInputDiv {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
}
.modalInputDiv label {
  width: 150px;
  min-width: 150px;
}
.modalInputDiv input[type="text"],
.modalInputDiv input[type="password"] {
  flex: 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.modalInputRight {
  width: 100px;
  min-width: 100px;
  display: flex;
  justify-content: flex-end;
}
.modalBtnRight {
  margin-left: 10px;
}
.fail {
  color: red;
  font-size: 0.85rem;
}
.success {
  color: green;
  font-size: 0.85rem;
}
</style>
